export enum InvoiceStatus {
  INVOICE_DRAFT = 'INVOICE_STATUS_INVOICE_DRAFT',
  INVOICE_PENDING = 'INVOICE_STATUS_INVOICE_PENDING',
  INVOICE_PAID = 'INVOICE_STATUS_INVOICE_PAID',
}

export interface Invoice {
  id: string
  status: InvoiceStatus
}
